export const config = {
    // apiBaseURL: 'http://localhost:8889',
    apiBaseURL: 'https://safe-disclosure.ucentralasia.org/server',
    gRecaptchaSiteKey: '6Le42MMUAAAAAMAP5XLURRYAFMBbganPc49jklt4',
    defaultLang: 'en',
    gaSiteKey: 'UA-151356708-2'
}